module.exports = __webpack_public_path__ + "img/struc-steel-member.24d1f4d2.jpg";